import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Form from 'components/Profile/Consent/Form';
import Landing from 'components/Profile/Consent/Landing';
import Authorization from 'components/Profile/Consent/Authorization';

const VIEWS = {
  LANDING: 'landing',
  FORMS: 'forms',
  AUTHORIZATIONS: 'authorizations',
};

const Consent = () => {
  const { sectionData, mergeSection, refreshProfile }: any = useOutletContext();
  const [view, setView] = useState(VIEWS.LANDING);

  const { consent, contacts, treatmentConsents } = sectionData || {};

  const backToLanding = () => setView(VIEWS.LANDING);

  const handleTreatmentConsentSigned = (data) =>
    mergeSection('treatment', treatmentConsents.map((form) => (data || []).find(({ id }) => id === form.id) || form));

  if (view === VIEWS.FORMS) return <Form onBack={backToLanding} />;
  if (view === VIEWS.AUTHORIZATIONS) {
    return <Authorization contacts={contacts} onRefresh={refreshProfile} onBack={backToLanding} />;
  }

  return (
    <Landing
      consentForms={consent}
      treatmentConsents={treatmentConsents}
      authorizedCount={contacts?.authorized?.length}
      onOpenForms={() => setView(VIEWS.FORMS)}
      onOpenAuthorizations={() => setView(VIEWS.AUTHORIZATIONS)}
      onTreatmentConsentSigned={handleTreatmentConsentSigned}
    />
  );
};

export default Consent;
